export default __webpack_public_path__ + "static/media/FemaleIcon.2e2f2445.svg";